import React from 'react';
import { JobSearchProvider } from '../../../context/JobSearchContext';
import LocumJobsContent from './LocumJobsContent';

const LocumJobs = () => {
  return (
    <JobSearchProvider>
      <LocumJobsContent />
    </JobSearchProvider>
  );
};

export default LocumJobs;
